import styled, { css } from 'styled-components'
import { colors } from 'web-makeup/dist/design-system/config/data/theme'

interface ButtonProps {
  rounded?: boolean
  backgroundColor?: string
  borderColor?: string
  hoverBackground?: string
  hoverColor?: string
  hoverBorder?: string
  buttonHeight?: string
  fullWidth?: boolean
  padding?: string
  fontSize?: string
  disabled?: boolean
  noWrap?: boolean
  color?: string
  fontWeight?: string
}
const hoverEffects = {
  '#1DA1F2': '#1C8FD6',
  '#1936D0': '#3269D5',
  '#EDEDED': '#D8D8D8',
  '#9B9B9B': '#9E9E9E',
  '#202020': '#202020',
  '#9E9E9E': '#9B9B9B',
}

const buttonStyles = css<ButtonProps>`
  transition: all 0.2s ease-in-out;
  background: ${({ backgroundColor, disabled }) =>
    disabled ? colors.radagast : backgroundColor ? backgroundColor : colors.action1};
  ${({ rounded }) => (rounded ? `border-radius: 6.25rem;` : `border-radius: 0.375rem;`)}
  ${({ borderColor }) => borderColor && `border: 1px solid ${borderColor};`}
  &:hover {
    background: ${({ hoverBackground, backgroundColor, disabled }) =>
      disabled
        ? colors.radagast
        : hoverBackground
          ? hoverBackground
          : backgroundColor && hoverEffects[backgroundColor]};
    ${({ hoverColor }) => hoverColor && `color: ${hoverColor};`}
    ${({ hoverBorder }) => hoverBorder && `border-color: ${hoverBorder};`}
  }
  padding: ${({ padding }) => (padding ? padding : `0 2rem`)};
  color: ${({ color }) => (color ? color : `white`)};
  font-weight: ${({ fontWeight }) => (fontWeight ? fontWeight : `600`)};
  font-size: ${({ fontSize }) => (fontSize ? fontSize : `1rem`)};
  min-height: ${({ buttonHeight }) => (buttonHeight ? buttonHeight : `3.25rem`)};
  display: inline-flex;
  align-items: center;
  text-align: center;
  justify-content: center;
  cursor: pointer;
  ${({ fullWidth }) => fullWidth && `width: 100%;`}
  ${({ disabled }) => disabled && `cursor: not-allowed;`}
  ${({ noWrap }) => noWrap && `white-space: nowrap;`}
  > span {
    display: flex;
    align-items: center;
  }

  img {
    vertical-align: text-top;
    margin-right: 0.375rem;
  }

  &&& {
    text-decoration: none;
  }
`

export const Button = styled.button<ButtonProps>`
  ${buttonStyles};
`

export const Anchor = styled.a<ButtonProps>`
  ${buttonStyles};
`



// WEBPACK FOOTER //
// ./src/components/BrandDashboard/components/DefaultButton/DefaultButton.style.tsx